import type { ApiClient } from './client';

export type JobStatus = 'queued' | 'running' | 'succeeded' | 'failed';

export type JobResponse = {
  job_id: string;
  status: JobStatus;
  created_at: string;
  started_at?: string;
  finished_at?: string;
  /** Seconds since the worker picked the job up — sent only while running. */
  elapsed_s?: number;
  result?: Record<string, unknown>;
  error?: string;
  message?: string;
};

export type PostIdentifyResponse = {
  /** null on an immediate 200: there is no job row to poll. */
  job_id?: string | null;
  status: JobStatus;
  created_at?: string;
  status_url?: string;
  result?: Record<string, unknown>;
};

export type DetectApi = ReturnType<typeof createDetectApi>;

export function createDetectApi(client: ApiClient, postUrl: string, getUrl: string) {
  // getUrl comes from /config.json and usually ends in a slash; joining it raw
  // would produce //v1/jobs/{id}.
  const jobsUrl = `${getUrl.replace(/\/+$/, '')}/v1/jobs`;
  return {
    postIdentify(url: string, signal?: AbortSignal): Promise<PostIdentifyResponse> {
      return client.request<PostIdentifyResponse>(postUrl, {
        method: 'POST',
        body: { url },
        signal,
      });
    },
    getJob(jobId: string, signal?: AbortSignal): Promise<JobResponse> {
      return client.request<JobResponse>(`${jobsUrl}/${encodeURIComponent(jobId)}`, {
        method: 'GET',
        signal,
      });
    },
  };
}
